var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterval = function SvgInterval(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m32.57 50.543 8.39-10.125V19.8h-2v19.897l-7.93 9.57z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M70 40c0 16.569-13.431 30-30 30-16.568 0-30-13.431-30-30 0-16.568 13.432-30 30-30 16.569 0 30 13.432 30 30m-2 0c0 15.464-12.536 28-28 28S12 55.464 12 40s12.536-28 28-28 28 12.536 28 28",
    clipRule: "evenodd"
  })));
};
export default SvgInterval;